import i18n from './i18n';
import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Header from './components/Header';
import Home from './components/Home';
import KitLumina from './components/KitLumina';
import AboutPage from './components/AboutPage';
import Blog from './components/Blog';
import Contato from './components/Contato';
import Footer from './components/Footer';
import AOS from 'aos';
import 'aos/dist/aos.css';
import './App.css';

function AppContent() {
  const location = useLocation();

  useEffect(() => {
    AOS.init({
      duration: 1000,
      easing: 'ease-in-out',
      once: true,
      mirror: false
    });
  }, []);

  useEffect(() => {
    const applyDetectedLanguage = async () => {
      try {
        const cached = localStorage.getItem('detectedLang');
        if (cached) {
          i18n.changeLanguage(cached);
          return;
        }
        const response = await fetch('https://ipapi.co/json/');
        if (!response.ok) throw new Error('geo failed');
        const data = await response.json();
        const country = (data && data.country_code) || '';
        let lang = 'en';
        if (country === 'BR') lang = 'pt';
        else if (country === 'ES') lang = 'es';
        i18n.changeLanguage(lang);
        localStorage.setItem('detectedLang', lang);
      } catch (e) {
        i18n.changeLanguage('en');
      }
    };
    applyDetectedLanguage();
  }, []);

  useEffect(() => {
    AOS.refresh();
  }, [location]);

  // Garantir que ao mudar de rota a página volte ao topo
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, [location.pathname]);

  return (
    <div className="App">
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/kit-lumina" element={<KitLumina />} />
        <Route path="/sobre" element={<AboutPage />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/contato" element={<Contato />} />
      </Routes>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
